import { render, staticRenderFns } from "./odoo-partner.vue?vue&type=template&id=0a8b3f6a&"
import script from "./odoo-partner.vue?vue&type=script&lang=js&"
export * from "./odoo-partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports